/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssistanceState {
    Unknown = 0,
    None = 1,
    RequireAssistance = 2,
    BargingIn = 3,
    Listening = 4,
    Whispering = 5,
    Conference = 6,
}
